<template>
  <b-modal
    v-model="isActive"
    has-modal-card
    trap-focus
    scroll="keep"
    aria-role="dialog"
    aria-label="Confirm changement etat"
    :aria-modal="true"
    :on-cancel="close"
  >
    <div class="modal-card change-etat-modal">
      <header class="modal-card-head">
        <H3TitleView class="modal-card-title"
          >{{ $t("ConfirmChangementEtat.title").toString() }}
        </H3TitleView>
      </header>
      <section class="modal-card-body">
        <H4TitleView>{{ $t("ConfirmChangementEtat.subtitle").toString() }}</H4TitleView>
        <div class="mt-5">
          <b-button
            class="no-hover"
            :icon-left="getIcon(oldEtatProjet)"
            :type="getColor(oldEtatProjet)"
            outlined
            >{{ $t(oldEtatProjet) }}
          </b-button>
          <b-icon class="mt-2" icon="arrow-right"></b-icon>
          <b-button
            class="no-hover"
            :icon-left="getIcon(newEtatProjet)"
            :type="getColor(newEtatProjet)"
            outlined
            >{{ $t(newEtatProjet) }}
          </b-button>
        </div>
        <div class="mt-5">
          <span v-if="newEtatProjet === 'EN_PAUSE'">{{
            $t("ConfirmChangementEtat.pause-projet")
          }}</span>
          <span v-if="newEtatProjet === 'ARCHIVE'">{{
            $t("ConfirmChangementEtat.stop-projet")
          }}</span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :label="$t('annuler')" @click="close" />
        <b-button :label="$t('valider')" type="is-primary" @click="validate" />
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import type { EtatProjet } from "@/model/bean/GeneratedDTOs"
import { defineComponent, PropType } from "vue"
import H3TitleView from "./H3TitleView.vue"
import H4TitleView from "./H4TitleView.vue"
import { BButton, BIcon, BModal } from "buefy"

export default defineComponent({
  name: "ConfirmChangementEtat",
  components: {
    H3TitleView,
    H4TitleView,
    BButton,
    BIcon,
    BModal,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    oldEtatProjet: {
      type: String as PropType<EtatProjet>,
      required: true,
    },
    newEtatProjet: {
      type: String as PropType<EtatProjet>,
      required: true,
    },
  },

  emits: ["update:modelValue", "confirm"],
  computed: {
    isActive: {
      get(): boolean {
        return this.modelValue
      },
      set(value: boolean): void {
        this.$emit("update:modelValue", value)
      },
    },
  },
  methods: {
    getIcon(etat: EtatProjet): string {
      if (etat === "ACTIF") {
        return "play-circle"
      } else if (etat === "ARCHIVE") {
        return "stop-circle"
      }
      return "pause-circle"
    },

    getColor(etat: EtatProjet): string {
      if (etat === "ACTIF") {
        return "is-success"
      } else if (etat === "ARCHIVE") {
        return "is-danger"
      }
      return "is-warning"
    },

    close(): void {
      this.isActive = false
    },

    validate(): void {
      this.$emit("confirm")
      this.close()
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.modal.hidden {
  display: none;
}

.modal-card-body {
  max-height: 80vh;
  overflow-y: auto !important;
}

.no-hover {
  &:not(.disable):hover {
    pointer-events: none;
  }
}

.change-etat-modal {
  width: 600px;
}

@media screen and (min-width: $fullhd) {
  .change-etat-modal {
    width: 80vw;
  }
}
</style>
